import { defineMessages } from 'react-intl';

const _default_1: {
	actionMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageSelectorLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelNameLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addLabelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceCommentCreateActionCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	actionMessage: {
		id: 'ai-mate.message-actions.confluence-add-label.action-message',
		defaultMessage:
			"Here's the label I suggest adding to the page {name}. Take a look over it, then select <bold>Add Label</bold> when you're ready.",
		description:
			'Message text displayed in an action card within the AI conversation interface when the AI suggests adding a label to a Confluence page. Shown as the main message text in the action card body. The name placeholder will be substituted with the target Confluence page name (e.g., "Project Planning"). The <bold> tags will be rendered as bold text for "Add Label". The purpose is to present the AI-suggested label to the user for review and provide clear instructions on how to proceed with adding the label to the page.',
	},
	pageSelectorLabel: {
		id: 'ai-mate.message-actions.confluence-add-label.space-selector-label',
		defaultMessage: 'Page',
		description:
			'Label text displayed above or next to a page selector dropdown in the Confluence add label action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the page selector control, which allows users to choose which Confluence page the label will be added to.',
	},
	labelPlaceholder: {
		id: 'ai-mate.message-actions.confluence-add-label.page-content-placeholder',
		defaultMessage: 'Add your label here',
		description:
			'Placeholder text displayed in a text input field within the Confluence add label action card in the AI conversation interface. Shown as placeholder text when the input field is empty. The purpose is to guide users on what they should enter in the label input field, prompting them to enter or edit the label name that will be added to the Confluence page.',
	},
	labelNameLabel: {
		id: 'ai-mate.message-actions.confluence-add-label.label-name-label',
		defaultMessage: 'Label name',
		description:
			'Label text displayed above or next to a text input field for the label name in the Confluence add label action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the label name input field, which allows users to enter or edit the name of the label that will be added to the Confluence page.',
	},
	addLabelButton: {
		id: 'ai-mate.message-actions.confluence-add-label.publish-button',
		defaultMessage: 'Add label',
		description:
			'Button label displayed on the primary action button in the Confluence add label action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card. When clicked, it adds the label to the selected Confluence page. The purpose is to provide a clear call-to-action for users to confirm and execute adding the label to the page.',
	},
	confluenceCommentCreateActionCardTitle: {
		id: 'ai-mate.message-actions.confluence-add-label.action-card-title',
		defaultMessage: 'Add label',
		description:
			'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests adding a label to a Confluence page. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is adding a label to an existing Confluence page.',
	},
});
export default _default_1;
